import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStamp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 21H20",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5455 13.08L8.92727 5.61C8.8595 5.29502 8.86373 4.96901 8.93965 4.65586C9.01558 4.3427 9.16128 4.05031 9.36609 3.8001C9.57089 3.54989 9.82962 3.34818 10.1233 3.20974C10.4171 3.07131 10.7383 2.99964 11.0636 3H12.9364C13.2617 2.99964 13.5829 3.07131 13.8767 3.20974C14.1704 3.34818 14.4291 3.54989 14.6339 3.8001C14.8387 4.05031 14.9844 4.3427 15.0603 4.65586C15.1363 4.96901 15.1405 5.29502 15.0727 5.61L13.4545 13.08",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2727 13.0801H4.72727C4.32561 13.0801 4 13.4024 4 13.8001V17.4001C4 17.7977 4.32561 18.1201 4.72727 18.1201H19.2727C19.6744 18.1201 20 17.7977 20 17.4001V13.8001C20 13.4024 19.6744 13.0801 19.2727 13.0801Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgStamp;
